<div class="content-wrapper bg-white security-auth">
  <div class="container-fluid p-2">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-15">SECURE AUTH VERIFICATION</h4>
        </div>
      </div>
    </div>
    <div class="market-analysis-container">
      <div class="card-body">
        <div class="text-center">
          <b>Secure Auth Verification Status: </b>
          <button *ngIf="auth_enable" (click)="show_validate_otp = true" class="btn btn-success"
            style="color: white !important">
            Enabled
          </button>
          <span *ngIf="!auth_enable" class="badge bg-danger" style="color: white !important">Disabled</span>
        </div>
        <ng-container *ngIf="otp_option">
          <div class="mt-2 text-center">
            Please select below option to enable secure auth verification
          </div>
          <div class="casino-report-tabs mt-3">
            <ul class="nav nav-tabs">
              <li class="nav-item pointer">
                <a class="nav-link" (click)="display_otp()" [class.active]="show_otp">Enable Using Mobile App</a>
              </li>
              <!-- <li class="nav-item pointer"><a class="nav-link">Enable Using Telegram</a></li> -->
            </ul>
          </div>
          <div *ngIf="show_otp" class="tab-content mt-4">
            <div class="tab-pane mobile-app" [class.active]="show_otp">
              <div class="loader-overlay" *ngIf="show_loader">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <div class="text-center">
                <div class="mt-3">
                  Please enter below auth code in your 'Secure Auth Verification
                  App'.
                </div>
                <div class="mt-3">
                  <div class="verify-code">{{ otp_digits }}</div>
                </div>
                <div class="mt-3">
                  <b>If you haven't downloaded,<br />please download 'Secure
                    Auth Verification App' from below link.</b>
                </div>
                <div class="mt-3">
                  Using this app you will receive auth code during login
                  authentication
                </div>
                <div class="mt-3">
                  <a class="btn btn-primary" download href="/assets/apk/WhiteLabel.apk"><i
                      class="fab fa-android"></i><span> Download on the Android</span></a>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="otp_validate">
          <div class="p-1">
            <div class="text-center">
              <div class="mt-3">
                <b>If you haven't downloaded,<br />please download 'Secure Auth
                  Verification App' from below link.</b>
              </div>
              <div class="mt-3">
                Using this app you will receive auth code during login
                authentication
              </div>
              <div class="mt-3">
                <a class="btn btn-primary" download href="/assets/apk/WhiteLabel.apk"><i
                    class="fab fa-android"></i><span> Download on the Android</span></a>
              </div>
            </div>
            <div *ngIf="show_validate_otp" class="mt-2 mb-3 login-auth">
              <h3 class="text-center">Security Code Verification</h3>
              <div class="mt-3 text-center">
                Enter 6-digit code from your security auth verification App
              </div>
              <form role="form" autocomplete="off" (ngSubmit)="submitOtp()" #otpForm="ngForm" class="mt-3">
                <div style="
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                  ">
                  <div *ngFor="let i of [1, 2, 3, 4, 5, 6]; let index = index">
                    <div style="display: flex; align-items: center">
                      <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input"
                        [(ngModel)]="otp[index]" name="otp{{ index }}" (ngModelChange)="onOtpInputChange(index, $event)"
                        #otpInput />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>